import { Globe } from "lucide-react";
import { CollapsibleCard } from "../CollapsibleCard";

const parts = (visits, chats, visitorId) => [
  visits > 0 && "Google Analytics visits",
  chats && "live chats",
  visitorId && "who is visiting",
].filter(Boolean);

// Folds the Brand's Journey chart, Live Chat and Visitor ID into one tap-to-open card
export const WebsiteStoryDropdown = ({ visits = 0, hasChats, hasVisitorId, children }) => {
  const bits = parts(visits, hasChats, hasVisitorId);
  return (
    <CollapsibleCard
      testId="website-story-dropdown"
      outerClass="relative mt-6"
      containerClass="rounded-2xl p-5 md:p-6 bg-[#0c465f] ring-1 ring-cyan-400/25 hover:ring-cyan-300/40 transition-shadow"
      chevronClass="text-cyan-300"
      hintClass="text-cyan-200/70"
      header={
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-cyan-500/15 flex items-center justify-center flex-shrink-0">
            <Globe className="w-5 h-5 text-cyan-300" />
          </div>
          <div className="min-w-0">
            <p className="text-white text-base md:text-lg font-bold">Your Website Story</p>
            {bits.length > 0 && (
              <p className="text-cyan-100/70 text-xs md:text-sm" data-testid="website-story-summary">
                {bits.length > 1 ? `${bits.slice(0, -1).join(", ")} and ${bits[bits.length - 1]}` : bits[0]}
              </p>
            )}
          </div>
        </div>
      }
    >
      {children}
    </CollapsibleCard>
  );
};
